export const toCamelCaseKey = (key: string): string => key.replace(/(_\w)|(-\w)/g, (k: string) => k[1].toUpperCase())

export const toCamelCase = (object: any): any => {
    let transformedObject = object
    if (typeof object === 'object' && object !== null) {
        if (object instanceof Array) {
            transformedObject = object.map(toCamelCase)
        } else {
            transformedObject = {}
            Object.keys(object).map((key: any) => {
                if (object[key] !== undefined) {
                    const newKey = toCamelCaseKey(key)
                    transformedObject[newKey] = toCamelCase(object[key])
                }
                return
            })
        }
    }
    return transformedObject
}

export const toSnackCaseKey = (key: string): string =>
    key
        .replace(/\.?([A-Z]+)/g, (_, y: string) => {
            return `_${y.toLowerCase()}`
        })
        .replace(/^_/, '')

export const isCamelCase = (key: string): boolean => /\.?([A-Z]+)/g.test(key)

export const toSnackCase = (object: any): any => {
    let transformedObject = object
    if (typeof object === 'object' && object !== null) {
        if (object instanceof Array) {
            transformedObject = object.map(toSnackCase)
        } else {
            transformedObject = {}
            Object.keys(object).map((key: string) => {
                if (object[key] !== undefined) {
                    const newKey = toSnackCaseKey(key)
                    transformedObject[newKey] = toSnackCase(object[key])
                }
                return
            })
        }
    }
    return transformedObject
}

/**
 * Handles the click event on a dropdown component.
 * 
 * @param e - The click event object.
 * @param openStatus - The current open status of the dropdown.
 * @param triggerElement - A reference to the trigger element of the dropdown.
 * @param panelElement - A reference to the panel element of the dropdown.
 * @returns Returns `true` if the click event occurred on the panel element, `false` otherwise.
 */
export const handleDropdownClick = (
    e: MouseEvent,
    openStatus: boolean,
    triggerElement: React.MutableRefObject<null>,
    panelElement: React.MutableRefObject<null>
): boolean => {
    if (triggerElement.current && (triggerElement.current as HTMLElement).contains(e.target as HTMLElement)) {
        return !openStatus
    }
    if (panelElement.current && (panelElement.current as HTMLElement).contains(e.target as HTMLElement)) {
        return true
    } return false
}

export const getRequestHeader = (token: string, type?: string) => {
    return { headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': type || 'application/json' } }
}

export const passwordRegEx =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[.!@#$%^&*_\-+=|?])[a-zA-Z0-9.!@#$%^&*_\-+=|?]{8,}$/

export const emailRegEx =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

export const phoneRegEx = /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/
